import { createRoot } from 'react-dom/client'
import { pdfjs } from 'react-pdf'
import App from './App.tsx'
import './index.css'
import { initSentry } from '@/lib/sentry'
import { initPostHog } from '@/lib/posthog'
import { initWebVitals } from '@/lib/web-vitals'
import * as Sentry from '@sentry/react'
import { capturePostHogEvent } from '@/lib/posthog'
import { POSTHOG_EVENTS } from '@/lib/posthog-events'

// Configure PDF.js worker globally before app initialization
pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;
initSentry();
initPostHog();
initWebVitals();

createRoot(document.getElementById("root")!).render(<App />);

// Cold start: performance.now() measures ms since timeOrigin (navigation start).
// After render is scheduled, this captures total JS bootstrap time.
const coldStartMs = performance.now();
Sentry.setMeasurement('cold_start', coldStartMs, 'millisecond');
capturePostHogEvent(POSTHOG_EVENTS.web_vital_reported, {
  vital_name: 'cold_start',
  vital_value: coldStartMs,
  vital_rating: coldStartMs < 2000 ? 'good' : coldStartMs < 4000 ? 'needs-improvement' : 'poor',
});
